import { FeatureCollection, Point } from "geojson";

class WardLabels {
  static getData(): FeatureCollection<Point> {
    return {
      type: "FeatureCollection",
      features: [
        {
          type: "Feature",
          properties: { name: "Albert Park Ward" },
          geometry: { type: "Point", coordinates: [144.962776, -37.851720] },
        },
        {
          type: "Feature",
          properties: { name: "Alma Ward" },
          geometry: { type: "Point", coordinates: [144.999196, -37.862076] },
        },
        {
          type: "Feature",
          properties: { name: "Balaclava Ward" },
          geometry: { type: "Point", coordinates: [144.992219, -37.872431] },
        },
        {
          type: "Feature",
          properties: { name: "Elwood Ward" },
          geometry: { type: "Point", coordinates: [144.984126, -37.882013] },
        },
        {
          type: "Feature",
          properties: { name: "Lakeside Ward" },
          geometry: { type: "Point", coordinates: [144.973939, -37.847974] },
        },
        {
          type: "Feature",
          properties: { name: "Montague Ward" },
          geometry: { type: "Point", coordinates: [144.939334, -37.832326] },
        },
        {
          type: "Feature",
          properties: { name: "Port Melbourne Ward" },
          geometry: { type: "Point", coordinates: [144.926915, -37.839159] },
        },
        {
          type: "Feature",
          properties: { name: "South Melbourne Ward" },
          geometry: { type: "Point", coordinates: [144.961381, -37.834861] },
        },
        {
          type: "Feature",
          properties: { name: "St Kilda Ward" },
          geometry: { type: "Point", coordinates: [144.979521, -37.866923] },
        },
      ],
    };
  }
}

export default WardLabels;
